import React, { useCallback } from 'react';
import cn from 'classnames';
import Autocomplete, { AutocompleteProps, AutocompleteRenderInputParams } from '@mui/material/Autocomplete';

import { useTheme } from '../../../theme';
import { AutocompleteOption } from '../types';
import { InputProps } from '../../Input/types';
import Input from '../../Input';

export interface Props extends Omit<AutocompleteProps<string | AutocompleteOption, false, true, true>, 'renderInput'> {
	InputProps?: InputProps;
	renderInput?: (params: AutocompleteRenderInputParams) => React.ReactNode;
}

const Dropdown: React.FC<Props> = ({ classes, InputProps, renderInput, ...restProps }) => {
	const { Dropdown: theme } = useTheme('BaseComponents');

	const renderInputHandler = useCallback(
		(params: AutocompleteRenderInputParams) => {
			const { classes: inputClasses, ...restInputProps } = InputProps ?? {};

			return (
				renderInput?.(params) ?? (
					<Input
						classes={{
							...inputClasses,
							labelIn: cn(theme.labelIn, inputClasses?.labelIn),
							withoutLabel: cn(theme.withoutLabel, inputClasses?.withoutLabel),
							outlined: cn(theme.outlined, inputClasses?.outlined)
						}}
						{...params}
						{...restInputProps}
					/>
				)
			);
		},
		[renderInput, InputProps]
	);

	return (
		<Autocomplete
			classes={{
				...classes,
				root: cn(theme.root, classes?.root),
				input: cn(theme.input, classes?.input),
				paper: cn(theme.paper, classes?.paper),
				listbox: cn(theme.listbox, classes?.listbox),
				option: cn(theme.option, classes?.option),
				endAdornment: cn(theme.endAdornment, classes?.endAdornment),
				popupIndicator: cn(theme.popupIndicator, classes?.popupIndicator)
			}}
			renderInput={renderInputHandler}
			{...restProps}
		/>
	);
};

export default Dropdown;
